import styled, { css } from 'styled-components'

export const StyledOTCLanding = styled.div`
  background: #fff;
`
export const StyledOTCInputArea = styled.div`
  margin: 23px 15px 0;
  background: #fafbfc;
  border: 1px solid ${({ theme }) => theme.colors.borderDefault};
  border-radius: 6px;
  height: 50px;
  box-sizing: border-box;
  padding: 0 15px 0 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  .otc-input {
    outline: none;
    border: 0;
    background: #fafbfc;
    caret-color: #098de6;
    border-radius: 6px;
    height: 100%;
    box-sizing: border-box;
    padding: 14px 15px;
    font-size: 15px;
    flex: 1;
    color: #000;
    font-weight: 500;
  }
  .otc-input-label {
    color: #000;
    font-size: 15px;
  }
`

interface StyledOTCApplyMessageProps {
  danger?: boolean
}
export const StyledOTCApplyMessage = styled.div<StyledOTCApplyMessageProps>`
  margin-top: 12px;
  margin-right: 30px;
  text-align: right;
  font-size: 14px;
  color: ${({ danger }) => (danger ? '#f05a5a' : '#66717c')};
`

interface StyledOTCButtonProps {
  active?: boolean
}
export const StyledOTCButton = styled.div<StyledOTCButtonProps>`
  background: #c2c8cc;
  border-radius: 8px;
  color: #fff;
  text-align: center;
  height: 50px;
  line-height: 50px;
  font-size: 15px;
  margin: 30px 15px 20px;
  cursor: pointer;

  ${({ active }) =>
    active &&
    css`
      background: #098de6;
    `}
`

export const StyledOTCIntroduce = styled.ul`
  list-style-type: none;
  margin: 0 15px;
  font-size: 12px;
  padding: 0;
  line-height: 20px;
  color: #66717c;
  li {
    margin-bottom: 5px;
  }
`

export const StyledOTCHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .side-header {
    padding: 0 12px;

    .side-header-inner {
      position: relative;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      height: 52px;
    }
    .side-tab {
      flex: 1;
      text-align: center;
      height: 52px;
      line-height: 52px;
      font-style: normal;
      font-weight: 600;
      font-size: 15px;
      letter-spacing: 0.28px;
      color: #777a8c;
      transition: color 0.3s;
      text-align: center;
      width: 36px;
      margin: 0 10px;
    }
    .side-bottom-line {
      position: absolute;
      height: 2px;
      width: 36px;
      bottom: 4px;
      border-radius: 1px;
      left: 0;
      transition: transform 0.3s;
      background: #098de6;
    }
    &.active-0 {
      .side-tab:first-child {
        color: #098de6;
      }
      .side-bottom-line {
        transform: translateX(10px);
      }
    }
    &.active-1 {
      .side-tab:nth-child(2) {
        color: #098de6;
      }
      .side-bottom-line {
        transform: translateX(66px);
      }
    }
  }
`

export const StyledOTCMarket = styled.div`
  border: 0.5px solid ${({ theme }) => theme.colors.borderDefault};
  border-radius: 6px;
  padding: 0 11px 0 18px;
  margin-right: 15px;
  font-size: 13px;
  letter-spacing: 0.28px;
  color: #777a8c;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  width: 90px;
  height: 36px;
  .selected-market-arrow {
    width: 10px;
    height: 10px;
    position: relative;
    top: -2px;
  }
`

export const StyledOTCMask = styled.div<{ visible?: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.16);
  display: none;
  ${({ visible }) =>
    visible &&
    css`
      display: block;
    `}
`

export const StyledOTCModal = styled.div<{ iPhoneX?: boolean }>`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #f2f4f5;
  padding: 9px 0 21px;
  ${({ iPhoneX }) =>
    iPhoneX &&
    css`
      padding-bottom: 51px;
    `}
  .select-market-list {
    margin: 0 10px 10px;
    background: #ffffff;
    border-radius: 16px;
    padding: 0 10px;
    font-size: 17px;
    text-align: center;
    letter-spacing: 0.17px;
    color: #098de6;
  }
  .select-market-item {
    height: 56px;
    line-height: 56px;
    &:first-child {
      border-bottom: 1px solid rgba(231, 231, 234, 0.5);
    }
    &:active {
      opacity: 0.5;
    }
  }
  .select-market-cancel {
    background: #ffffff;
    border-radius: 16px;
    font-size: 17px;
    letter-spacing: 0.17px;
    color: #000000;
    height: 55px;
    line-height: 55px;
    text-align: center;
    margin: 0 5px;
    &:active {
      opacity: 0.5;
    }
  }
`

export const StyledOTCUnsupported = styled.div`
  background: #fff;
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: space-between;
`
export const StyledOTCUnsupportedContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 17px;
  text-align: center;
  letter-spacing: 0.3px;
  .otc-unsupported-inner {
    padding: 0 20px;
    position: relative;
    top: -10px;
  }
  .unsupported-notice {
    color: rgba(0, 0, 0, 0.4);
    margin-bottom: 9px;
  }
  .unsupported-area-link {
    color: #098de6;
  }
`

export const StyledOTCUnsupportedSurvey = styled.div`
  position: fixed;
  bottom: calc(16px + env(safe-area-inset-bottom, 0));
  width: 100%;
  box-sizing: border-box;
  padding: 0 16px;
  text-align: center;

  .unsupported-survey {
    color: #fff;
    background: #098de6;
    display: block;
    border-radius: 8px;
    height: 50px;
    line-height: 50px;
    font-size: 15px;
    cursor: pointer;
  }
`
